import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ScopedCssBaseline } from "@mui/material";
import createCache from "@emotion/cache";
import { CacheProvider, css } from "@emotion/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const rootElement = document.getElementById(
  "jukebox-music-search"
) as HTMLElement;

const shadowContainer = rootElement.attachShadow({ mode: "open" });
const shadowRootElement = document.createElement("div");
shadowContainer.appendChild(shadowRootElement);

const cache = createCache({
  key: "css",
  prepend: true,
  container: shadowContainer,
});

const root = ReactDOM.createRoot(shadowRootElement);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <CacheProvider value={cache}>
        <ScopedCssBaseline
          sx={{ background: "none", display: "flex", justifyContent: "center" }}
        >
          <App />
        </ScopedCssBaseline>
      </CacheProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
